import { Box, Menu, MenuItem, Typography } from "@mui/material";
import { FC, useState, MouseEvent } from "react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

export const User: FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isAuthenticated = useIsAuthenticated();
  const { accounts, instance } = useMsal();
  const profile = instance.getActiveAccount() || accounts[0];

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return isAuthenticated ? (
    <>
      <Box
        minWidth={200}
        display="flex"
        alignItems="center"
        justifyContent="space-around"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ cursor: "pointer" }}
      >
        <AccountCircleOutlinedIcon color="MFT_OFF_WHITE" />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="flex-end"
        >
          <Typography variant="caption" color="MFT_OFF_WHITE">
            {profile?.name || profile?.username || "User"}
          </Typography>
          <Typography variant="caption" color="MFT_OFF_WHITE">
            {profile?.username || ""}
          </Typography>
        </Box>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => instance.logoutRedirect()}>Sign out</MenuItem>
      </Menu>
    </>
  ) : null;
};
